import PhoneNumber from "awesome-phonenumber";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import CustomerSummary from "interfaces/CustomerSummary";
import DataTableApiResponse from "interfaces/DataTableApiResponse";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import getBaseUrl from "utils/getBaseUrl";
import DataTable from "./../common/DataTable";
import ContentLoading from "components/common/ContentLoading";

interface State {
    data: CustomerSummary[];
    spinner: boolean;
}

export default class IndexBc extends React.Component<
    RouteComponentProps<{}>,
    State
> {
    private baseUrl: string;
    private mainDataTableRef: React.RefObject<DataTable>;
    private dataTableRef: React.RefObject<HTMLTableElement>;

    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {
            data: [],
            spinner: true,
        };

        this.baseUrl = getBaseUrl();
        this.mainDataTableRef = React.createRef();
        this.dataTableRef = React.createRef();

        this.dataTableData = this.dataTableData.bind(this);
        this.dataTableDataFilter = this.dataTableDataFilter.bind(this);
        this.handleDataTableDraw = this.handleDataTableDraw.bind(this);
    }

    public render() {
        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>Customers</BreadcrumbLink>
                    </Breadcrumb>
                    <div className="card card--datatables">
                        <div className="card-block">
                            <h2 className="card__title">Business Central Customers</h2>
                            <div className="datatable-wrapper">
                                <DataTable
                                    ajaxUrl={this.baseUrl + "api/customers/1/summary"}
                                    useAuth={true}
                                    ajaxData={this.dataTableData}
                                    ajaxDataFilter={this.dataTableDataFilter}
                                    onDraw={this.handleDataTableDraw}
                                    ref={this.mainDataTableRef}
                                    stateSave={true}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ width: "10%" }}>ID</th>
                                            <th style={{ width: "20%" }}>Customer Name</th>
                                            <th style={{ width: "15%" }}>City</th>
                                            <th style={{ width: "15%" }}>Contact Person</th>
                                            <th style={{ width: "12%" }}>Phone</th>
                                            <th style={{ width: "13%" }}>Email</th>
                                            {/*<th style={{ width: "15%" }}>BC Status</th>*/}
                                        </tr>
                                    </thead>
                                    <tbody></tbody>
                                </DataTable>
                                {this.state.spinner ? (
                                    <ContentLoading />
                                ) : (
                                    <table className="d-none" ref={this.dataTableRef}>
                                        <tbody>
                                            {this.state.data.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>
                                                        <Link to={"/customers/" + item.id}>{item.id}</Link>
                                                    </td>
                                                    <td>
                                                        <Link to={"/customers/" + item.id}>{item.name}</Link>
                                                    </td>
                                                    <td>
                                                        <Link to={"/customers/" + item.id}>{item.city}</Link>
                                                    </td>
                                                    <td>
                                                        <Link to={"/customers/" + item.id}>{item.contact}</Link>
                                                    </td>
                                                    <td>
                                                        <Link to={"/customers/" + item.id}>
                                                            {item.phone &&
                                                                new PhoneNumber(item.phone, "US").getNumber(
                                                                    "national"
                                                                )}
                                                        </Link>
                                                    </td>
                                                    <td>
                                                        <Link to={"/customers/" + item.id}>{item.email}</Link>
                                                    </td>
                                                    {/*<td>*/}
                                                    {/*    <Link to={"/customers/" + item.id}>{item.bcStatus}</Link>*/}
                                                    {/*</td>*/}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public async componentDidMount() {
        document.title = "Business Central Customers - " + SITE_NAME;
    }

    private dataTableData(data: any) {
        let sortFields = [
            "id",
            "name",
            "city",
            "contact",
            "phone",
            "email",
            "bcStatus",
        ];

        let newData = {
            pageNumber: Math.floor(data.start / data.length) + 1,
            pageSize: data.length,
            sortField: sortFields[data.order[0].column],
            sortDirection: data.order[0].dir === "asc" ? 1 : 2,
            search: data.search.value,
            draw: data.draw,
        };

        return newData;
    }

    private dataTableDataFilter(data: string) {
        var json = JSON.parse(data) as DataTableApiResponse<CustomerSummary>;

        this.setState({
            data: json.items,
            spinner: false,
        });

        let tableData = [];
        let $tr = $(this.dataTableRef.current!).find("tr");
        for (let i = 0; i < $tr.length; i++) {
            let $td = $tr.eq(i).find("td");
            let rowData = [];
            for (let j = 0; j < $td.length; j++) {
                rowData.push($td.eq(j).clone(true, true).html());
            }
            tableData.push(rowData);
        }

        let newData = {
            draw: json.draw,
            recordTotal: json.metadata.totalItemCount,
            recordsFiltered: json.metadata.totalItemCount,
            data: tableData,
        };

        return JSON.stringify(newData);
    }

    private handleDataTableDraw(dataTable: any) {
        $(dataTable).off("click", "tr");
        $(dataTable).find("a:not([href='#'])").off("click");
        $(dataTable)
            .find("tbody tr")
            .css("cursor", "pointer");

        $(dataTable)
            .find("a:not([href='#'])")
            .on("click", (e) => {
                e.preventDefault();
                this.props.history.push($(e.currentTarget).attr("href")!);
            });

        $(dataTable).on("click", "tr", (e) => {
            const rowId = $(e.currentTarget).find("td").first().text().trim();
            if (rowId) {
                this.props.history.push(`/customers/${rowId}`);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/customers/Index-BC.tsx